// 9fbef606107a605d69c0edbcd8029e5d
import { css } from 'styled-components';
import { getIconPath } from '@tcp/core/src/utils';

export default css`
  display: ${(props) => props.theme.brandSpecificStyles.COUNTRY_SELECTOR.DISPLAY};
  float: right;
  padding-top: 3px;
  & > a {
    display: inline-flex;
  }

  ${(props) =>
    props.showInFooter
      ? `
    padding: 34px 0 32px;
    float: left;
@media ${props.theme.mediaQuery.mediumMax} {
    ${
      props.isFooterRedesignEnabled &&
      `padding-top: 5px;
      padding-bottom: 5px;
    border-bottom: 1px solid #D8D8D8;
    width: 100%;
    background-color: #FAFAFA;
    `
    }
  }

    @media ${props.theme.mediaQuery.large} {
      float: right;

      ${props.isFooterRedesignEnabled ? 'padding: 0;' : 'padding: 22px 0 12px;'}
    }
    `
      : ``}

  .countrySelector {
    display: ${(props) =>
      props.theme.brandSpecificStyles.COUNTRY_SELECTOR.COUNTRY_SELECTOR_DISPLAY};
  }
  .county-selector-link {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .countrySelector__shipTo {
    line-height: 20px;
  }

  .countrySelector__flag-icon {
    margin: 0 2px 0px ${(props) => props.theme.spacing.ELEM_SPACING.SM};
    cursor: pointer;
    height: 20px;
    padding: 11px;
    border-radius: 50%;

    img {
      display: flex;
      font-size: 10px;
      line-height: 12px;
    }
  }

  .countrySelector__locale {
    border-right: 1px solid ${(props) => props.theme.colorPalette.gray['600']};
    cursor: pointer;
    display: inline-block;
    padding: 0 6px;
    height: 13px;
    line-height: 14px;
    text-transform: ${(props) => (props.isFooterRedesignEnabled ? 'capitalize' : 'uppercase')};
    font-weight: ${(props) => props.theme.fonts.fontWeight.bold};
    :first-child {
      padding-left: 0;
    }

    :last-child {
      border: none;
    }

    @media ${(props) => props.theme.mediaQuery.medium} {
      margin-top: 4px;
    }
  }
  .language-name {
    ${(props) =>
      !props.isFooterRedesignEnabled &&
      `
       &:after {
      content: '';
      width: 10px;
      height: 10px;
      display: inline-flex;
      background: url('${getIconPath('down_arrow_icon_white', props)}') no-repeat right
        center;
      ${
        props.isStickyHeaderBgColorEnabled
          ? `
            color: ${props.theme.colors.WHITE} !important;
          `
          : ``
      }
    }
    `}
  }
  .countrySelector__locale--selected {
    color: ${(props) => props.theme.colors.WHITE};
    ${(props) =>
      props.isStickyHeaderBgColorEnabled
        ? `
          color: ${props.theme.colors.WHITE} !important;
        `
        : ``}
  }
  .countrySelector__locale--disabled {
    color: ${(props) => props.theme.colorPalette.gray['600']};
  }
`;
